import React from "react";
import { VR_RE_IMAGES } from "../../../data/vrRealEstateImages";
import { trackOsharRealEstateView } from "../../../utils/analytics";

const statusClass = (status) => {
  if (status === "Available") return "is-available";
  if (status === "Limited") return "is-limited";
  return "is-soon";
};

const FeaturedProperties = ({ listings, onViewDetails }) => {
  return (
    <section className="oshar-re-featured" aria-labelledby="oshar-re-featured-title">
      <div className="oshar-inner">
        <h2 id="oshar-re-featured-title" className="oshar-re-section-title">
          Featured Properties
        </h2>
        <p className="oshar-re-section-lead">
          Curated listings across districts — availability will sync with on-chain inventory once
          minting is live.
        </p>
        <div className="oshar-re-featured__grid">
          {listings.map((L) => (
            <article key={L.id} className="oshar-re-feat-card">
              <div className="oshar-re-feat-card__media">
                <img src={VR_RE_IMAGES[L.imageKey]} alt="" loading="lazy" decoding="async" />
              </div>
              <div className="oshar-re-feat-card__body">
                <h3 className="oshar-re-feat-card__title">{L.title}</h3>
                <p className="oshar-re-feat-card__meta">
                  {L.district} · {L.assetType}
                </p>
                <p className="oshar-re-feat-card__price">{L.priceLabel}</p>
                <span className={`oshar-re-status ${statusClass(L.status)}`}>{L.status}</span>
                <button
                  type="button"
                  className="oshar-btn-outline oshar-re-btn-block"
                  onClick={() => {
                    trackOsharRealEstateView({
                      cta_id: "real_estate_featured_view_details",
                      section: "featured_properties",
                      tier: L.tierSlug || L.id,
                    });
                    onViewDetails(L);
                  }}
                >
                  View Details
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProperties;
